import { CardI } from "./Card_Comp";

const data:CardI[] = [
  {
   pkgName: "Starter",
   cardColor: "white",
   projectCount: "Easy, Simple Usage",
   surveyCount: "Unlimited Project, Surveys & Members",
   memberCount: "Online Forms",
   dayCount: "Subscription Basis",
   price: "Free",
   priceAnnual: "Free",
   descTitle: "COLLECT DATA FOR FREE",
   desc: "Are you a student trying to collect primary data?, or a professor doing research? Or you just want to see what Sebsib is all about. Then the Starter offer is for you"
  },
  {
    pkgName: "Managed",
    cardColor: "black",
    projectCount: "ODK Collect",
    surveyCount: "Power BI Integration",
    memberCount: "XLSForms Compatible",
    featureOne: "Unlimited forms & users",
    featureTwo: "Online Submissions",
    dayCount: "Subscription Basis",
    price: "2,000 Br",
    priceAnnual: "19,200 br",
    descTitle: "COLLECTING DATA PROFESSIONALLY",
    desc: "The Managed offer gives you a lot more in your data collection journey. If you have a background in data collection or want to conduct longer, more complex surveys; Then we recommend this offer. The features are more suited for professionals."
  },
  {
    pkgName: "Enterprise",
    cardColor: "yellow",
    projectCount: "Unlimted Projects, Surveys & Users",
    surveyCount: "Full Access to Features",
    memberCount: "No Subscription or License",
    featureOne: "On your premise",
    featureTwo: "24/7 Support & Training",
    dayCount: "One Time Purchase",
    price: "2,000 Br",
    priceAnnual: "19,200 br",
    descTitle: "OWN SEBSIB AND OWN YOUR DATA",
    desc: "The standard package offers you a lot more in your data collection journey. If you are collecting data regularly we recommend this package. Moreover we have an API interface for you to store the data collected directly into your database."
  }
]
export default data;